import React from "react";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import onboardingimg1 from "../../../../assets/onboarding-img1.svg";
import onboardingimg2 from "../../../../assets/onboarding-img2.svg";
import Title from "../Title";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";

// routes
import { Link } from "react-router-dom";
export const OnBoardingScreen = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>
        {/* <Header /> */}
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-wrapper survey-creation-box">
              <div className="form-heading text-center">
                <h3>Create a survey</h3>
                <p>How would you like to get started?</p>
              </div>
              <div className="row">
                <div className="col-lg-6 mb-3 mb-lg-0">
                  <Link to={"/ProcessDone?email="+email}>
                    <div className="myflex-item-left">
                      <div className="custom-card">
                        <div className="onboard-image">
                          <img className="imgoxauto" src={onboardingimg1} alt="Start from template" />
                        </div>
                        <div className="onboard-description">
                          <h5 className="texth5 onboard-name">Start from template</h5>
                          <p className=" onboard-text">Choose from our library of ready-to-use survey templates.</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6">
                  <Link to={"/ProcessDone?email="+email} >
                    <div className="myflex-item-right">
                      <div className="custom-card">
                        <div className="onboard-image">
                          <img className="imgoxauto" src={onboardingimg2} alt="Start from Scratch" />
                        </div>
                        <div className="onboard-description">
                          <h5 className="texth5 onboard-name">Start from Scratch</h5>
                          <p className=" onboard-text">Build your survey from scratch.</p>
                        </div>
                      </div>

                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default OnBoardingScreen;
